// base
import React, { useRef } from 'react';

// styles
import { StyledLineChartCard } from './style';

// libraries
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
} from 'chart.js';
import dayjs from 'dayjs';
import { Line, getDatasetAtEvent, getElementAtEvent } from 'react-chartjs-2';
import Paper from '@mui/material/Paper';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

export const LineChartCard = ({ entryData, title = 'title' }) => {
  const chartRef = useRef();
  const data = {
    labels: [
      // label 줄바꿈처리
      ...entryData.map((v) => [
        dayjs(v.attendanceDate).format('ddd'),
        dayjs(v.attendanceDate).format('DD')
      ])
    ],
    datasets: [
      {
        label: `Workers `,
        data: entryData?.map((v) => v.totalEmployees),
        fill: true,
        borderColor: 'rgb(64, 100, 255)',
        backgroundColor: (context) => {
          const bgColor = ['rgb(64, 100, 255, 0.5)', '#fff'];
          if (!context.chart.chartArea) {
            return;
          }

          const {
            ctx,
            data,
            chartArea: { top, bottom }
          } = context.chart;
          const gradientBg = ctx.createLinearGradient(0, top, 0, bottom);
          gradientBg.addColorStop(0, bgColor[0]);
          gradientBg.addColorStop(1, bgColor[1]);
          return gradientBg;
        }
      }
    ]
  };

  const maxDataValue = Math.max(...data.datasets[0].data); // 데이터 중에서 가장 큰 값 구하기

  let stepSize = 1;

  if (maxDataValue >= 5000) {
    stepSize = 1000;
  } else if (maxDataValue >= 500) {
    stepSize = 100;
  } else if (maxDataValue >= 50) {
    stepSize = 10;
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        left: 30
      }
    },
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        position: 'right',
        type: 'linear',
        ticks: {
          beginAtZero: true,
          stepSize: stepSize,
          callback: (value) => {
            if (value >= 1000) {
              return value / 1000 + 'k'; // 1000 이상의 값은 k (천 단위)로 표시
            } else {
              return value.toString(); // 그 외의 값은 그대로 표시
            }
          }
        }
      }
    }
  };

  const handleClick = (event) => {
    const chart = chartRef.current;
    if (!chart) return;

    const click_result = getElementAtEvent(chart, event);

    console.log('click_result', click_result);
  };

  return (
    <StyledLineChartCard>
      <Paper className={`chart-card`}>
        <div className="chart-card-header">
          <div className="chart-card-header-title">
            <p className="title">{title}</p>
            {/* <img className="icon" src={titleIcon} alt="icon" /> */}
          </div>
          {/* <div className="chart-card-header-content">{childContent}</div> */}
        </div>
        <div className="chart-card-content">
          <Line ref={chartRef} options={options} data={data} onClick={handleClick} />
        </div>
      </Paper>
    </StyledLineChartCard>
  );
};
